import {createSelector} from 'reselect';
import ReCaptchaTypes from '../../enums/ReCaptchaTypes';
import getRecaptchaStrategy from './getRecaptchaStrategy';

export default createSelector(
  [getRecaptchaStrategy],
  strategy => !!(strategy && strategy !== ReCaptchaTypes.DISABLED),
);
